var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gradeApplicationAdultJCE" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("Title", { attrs: { text: "成绩申请" } }),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "search",
                    staticClass: "search-form",
                    attrs: {
                      slot: "search",
                      inline: true,
                      model: _vm.condition,
                      rules: _vm.searchRules,
                      "label-width": "80px",
                    },
                    slot: "search",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "paper_plan_student_id" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: "请选择论文计划",
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.condition.paper_plan_student_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.condition,
                                            "paper_plan_student_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "condition.paper_plan_student_id",
                                      },
                                    },
                                    _vm._l(_vm.thesisPlanList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.loadData },
                                    },
                                    [_vm._v("确认")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.isShowDuplicate
                          ? _c("div", [
                              _c("div", { staticClass: "btn-box" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "link-btn",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.duplicateCheckClick,
                                            },
                                          },
                                          [_vm._v("提交申请")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                [
                                  _c("el-form-item", [
                                    _c("span", [
                                      _vm._v(
                                        "成绩申请截止时间：" +
                                          _vm._s(_vm.end_apply_time)
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "", align: "center", label: "流程标题" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(row.student_title) +
                                " + " +
                                _vm._s(row.process_title) +
                                " + " +
                                _vm._s(row.created_at)
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sign_img",
                    align: "center",
                    label: "手写签名",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("img", {
                            staticStyle: {
                              width: "200px",
                              height: "40px",
                              "object-fit": "contain",
                            },
                            attrs: { src: row.sign_img, alt: "" },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacher_title",
                    align: "center",
                    label: "评分老师",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "final_score",
                    align: "center",
                    label: "设计资料最终得分",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "imgs_url",
                    align: "center",
                    label: "快递单凭证",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.imgs_url
                            ? _c(
                                "div",
                                _vm._l(
                                  JSON.parse(row.imgs_url),
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        item.url
                                          ? _c("el-image", {
                                              staticStyle: { width: "50px" },
                                              attrs: {
                                                src: item.url,
                                                "preview-src-list": [item.url],
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "duplicateCheck",
          attrs: {
            title: "提交申请",
            visible: _vm.isShowDuplicateCheck,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDuplicateCheck = $event
            },
            close: _vm.duplicateCheckClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "duplicateCheck",
                  attrs: {
                    model: _vm.duplicateCheckData,
                    rules: _vm.duplicateCheckRules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "最终设计资料：", prop: "files_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "uploadDuplicateCheck",
                        attrs: {
                          listStyle: "text",
                          accept: ".docx,.doc,.pdf,.txt",
                          limit: 1,
                          isFile: true,
                          isAccept: true,
                        },
                        on: {
                          handleRemove: _vm.duplicateCheckHandleRemove,
                          handleChange: _vm.duplicateCheckHandleChange,
                        },
                      }),
                      _c("div", [
                        _c("span", { staticClass: "tips" }, [
                          _vm._v("说明：只能上传docx,doc,pdf,txt文件"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手写签名:", prop: "sign_img" } },
                    [
                      _c("esignHandle", {
                        ref: "duplicateCheckEsignHandle",
                        attrs: {
                          selectSignImg: _vm.duplicateCheckData.sign_img,
                        },
                        on: {
                          "update:selectSignImg": function ($event) {
                            return _vm.$set(
                              _vm.duplicateCheckData,
                              "sign_img",
                              $event
                            )
                          },
                          "update:select-sign-img": function ($event) {
                            return _vm.$set(
                              _vm.duplicateCheckData,
                              "sign_img",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "快递单凭证", prop: "imgs_url" } },
                    [
                      _c("FalConUpload", {
                        ref: "deliveryImg",
                        attrs: { multiple: false, isShowModal: false },
                        on: {
                          handleRemove: _vm.deliveryImgHandleRemove,
                          handleChange: _vm.deliveryImgHandleChange,
                        },
                      }),
                      _c("div", { staticClass: "tips" }, [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            " 将毕业综合考核打印后的纸质资料按如下地址寄出。快递单照片或截图也上传。"
                          ),
                          _c("br"),
                          _vm._v(" 快递只能用顺丰快递"),
                          _c("br"),
                          _vm._v(
                            " 快递地址：重庆市南岸区重庆医科大学继续教育学院"
                          ),
                          _c("br"),
                          _vm._v(" 收件人： 刘飞"),
                          _c("br"),
                          _vm._v(" 电话：62652913"),
                          _c("br"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowDuplicateCheck = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.duplicateCheckLoading,
                  },
                  on: { click: _vm.duplicateCheckSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }